















    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { store, StoreState } from '../../../store';
    import { mapState } from 'vuex';
    @Component({
        computed: {
			...mapState({
                'reports': (state: StoreState) => state.reports.scheduledReports,
			})
		}
    })
    export default class SchedulePicker extends Vue {
        data() {
            return {
            }
        }
        
        created() {
            this.$store.dispatch("getScheduledReports");
        }
       
        
    @Watch ('reports')
    SetCallDetails()
    {
        this.$store.dispatch("getScheduledReports");
    }

    getReportCriteria(id: any) {
        this.$store.dispatch("getScheduledReport", { id: id });
        this.$emit('resetError');
    }

    startDeleteReport(id: any, rev: any) {
        //alert('dele')
        //this.$store.dispatch('deleteScheduledReport', {id: id, rev: rev});
        this.$emit("deleteReport", { id, rev });
    }
    }
